/**
 * Returns whether the given field, of the given module type, with the given configuration, triggers
 * the module's fields repopulation.
 * @param {string} moduleType
 * @param {{}}     moduleFieldsConfig
 * @param {string} field
 * @return {boolean}
 */
export function moduleFieldTriggersPopulation(moduleType, moduleFieldsConfig, field) {
  return Array.isArray(moduleFieldsConfig)
    && moduleFieldsConfig.length > 0
    && (moduleFieldsConfig.find(fieldConfig => fieldConfig.field === field) || {}).triggerPopulation === true;
}


/**
 * List of default config values for module tpyes that alters module config
 * This is needed when the module is being edited in a composition type module because is not inside a board nor slot
 * @type {{string: string[]}}
 */
export const moduleTypesThatAltersFieldsConfigGetFieldsDefaultValues = {
  'modules.content': {
    slotType: 'slots.container-default.slot-default',
  },
};

/**
 * List of fields that modifies the module fields config, grouped by module type.
 * @type {{string: string[]}}
 */
export const fieldsThatAltersModuleFieldsConfig = {
  'modules.content': ['template'],
};

/**
 * List of module types that may have their fields config altered.
 * @type {string[]}
 */
export const moduleTypesThatAltersFieldsConfig = Object.keys(fieldsThatAltersModuleFieldsConfig);

/**
 * Returns whether the given field of the given module type triggers the modification of the
 * module's fields configuration.
 * @param {string} moduleType
 * @param {string} field
 * @return {boolean}
 */
export function moduleFieldTriggersFieldsConfigAlteration(moduleType, field) {
  return moduleTypesThatAltersFieldsConfig.includes(moduleType)
    && fieldsThatAltersModuleFieldsConfig[moduleType].includes(field);
}

const allowedAutomaticFieldsModules = ['modules.content'];

const reloadContentModulesConfig = {
  enableReloadContentInModule: false,
  types: [],
  checkContentIdIfNoTypes: false,
  reloadableParams: [],
};

export default {
  moduleTypesThatAltersFieldsConfig,
  moduleTypesThatAltersFieldsConfigGetFieldsDefaultValues,
  moduleFieldTriggersPopulation,
  moduleFieldTriggersFieldsConfigAlteration,
  allowedAutomaticFieldsModules,
  reloadContentModulesConfig,
};
